import React from "react";
import {
  Card,
  Descriptions,
  Avatar,
  Tag,
  Typography,
  Row,
  Col,
  Statistic,
  Divider,
} from "antd";
import { useTranslation } from "react-i18next";
import {
  BankOutlined,
  MailOutlined,
  PhoneOutlined,
  GlobalOutlined,
  EnvironmentOutlined,
} from "@ant-design/icons";

const { Title, Text } = Typography;

export function InstitutionInfoCard({ data }) {
  const { t } = useTranslation("institution");

  if (!data) return null;

  return (
    <Card className="revi-card" bordered={false} style={{ height: "100%" }}>
      <div
        style={{ display: "flex", alignItems: "flex-start", marginBottom: 20 }}
      >
        <Avatar
          src={data.avatar}
          size={84}
          icon={<BankOutlined />}
          style={{
            backgroundColor: "#f0f2f5",
            border: "1px solid #d9d9d9",
            marginRight: 16,
          }}
        />
        <div style={{ flex: 1 }}>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Title level={4} style={{ margin: 0 }}>
              {data.institutionName}
            </Title>
            <Tag color={data.active ? "success" : "error"}>
              {data.active ? t("profile.info.active") : t("profile.info.inactive")}
            </Tag>
          </div>
          <Text type="secondary" style={{ display: "block", marginTop: 4 }}>
            <MailOutlined /> {data.email}
          </Text>
          {data.phone && (
            <Text type="secondary" style={{ display: "block", marginTop: 2 }}>
              <PhoneOutlined /> {data.phone}
            </Text>
          )}
        </div>
      </div>

      <Divider style={{ margin: "12px 0" }} />

      {/*
        Estas dos cifras pintaban `pacientesN` y `terapeutasN`, que NO son
        cuantos hay: son el CUPO CONTRATADO. Un centro con 12 pacientes y 20
        contratados veia un 20 bajo el titulo "Usuarios".

        Ahora se ensena "ocupadas / contratadas". La ocupacion la cuenta el
        backend sobre documentos vivos; si no viene (respuesta antigua), se cae
        al comportamiento anterior para no dejar la tarjeta vacia.
      */}
      <Row gutter={16} style={{ textAlign: "center", marginBottom: 20 }}>
        <Col span={12}>
          <Statistic
            title={t("profile.info.patients")}
            value={data.ocupacion ? data.ocupacion.pacientes : data.pacientesN || 0}
            suffix={
              data.ocupacion ? `/ ${data.ocupacion.pacientesCupo}` : undefined
            }
            valueStyle={{ color: "#3f8600" }}
          />
        </Col>
        <Col span={12}>
          <Statistic
            title={t("profile.info.therapists")}
            value={
              data.ocupacion ? data.ocupacion.terapeutas : data.terapeutasN || 0
            }
            suffix={
              data.ocupacion ? `/ ${data.ocupacion.terapeutasCupo}` : undefined
            }
            valueStyle={{ color: "#1890ff" }}
          />
        </Col>
      </Row>

      <Descriptions column={1} size="small" bordered>
        <Descriptions.Item
          label={
            <>
              <EnvironmentOutlined /> {t("profile.info.address")}
            </>
          }
        >
          {data.address}, {data.city} ({data.country})
        </Descriptions.Item>
        <Descriptions.Item
          label={
            <>
              <GlobalOutlined /> {t("profile.info.web")}
            </>
          }
        >
          {data.website ? (
            <a href={data.website} target="_blank" rel="noreferrer">
              {t("profile.info.visitSite")}
            </a>
          ) : (
            "—"
          )}
        </Descriptions.Item>
      </Descriptions>
    </Card>
  );
}
